import { DEFAULT_VW, FOOTER_HEIGHT } from '@/core/constants/layout';

export const footerStyles = {
	root: {
		height: FOOTER_HEIGHT,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		px: 2,
		pb: {
			xs: 1.25
		},
		fontSize: `clamp(.75rem, ${DEFAULT_VW}, .875rem)`,
		color: 'text.secondary'
	},
	link: {
		fontWeight: 400
	}
};
